export * from './advance-search-with-finger-print.component';
